module.exports = __webpack_public_path__ + "static/img/8_yaozhui.9540fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/8_yaozhui.png
// module id = mXCt
// module chunks = 0